import React, { useRef, useState } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import Cookies from "js-cookie";
import { deviceRenameApi } from "../../api";
import { deviceRename } from "../../redux";
import { Alert } from "..";
import { withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FiEdit, FiSave, FiArrowLeft, FiHardDrive } from "react-icons/fi";

const EditDeviceComp = (props) => {
  const { t } = useTranslation();
  const { device, toggleEdit } = props;
  const dispatch = useDispatch();
  let form = useRef();
  const token = Cookies.get("token");
  const initialValues = {
    caption: device.caption || "",
  };
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });

  const submitForm = (values) => {  // دریافت values از Formik
    const data = new FormData(form.current);
    data.append("serial", device.serial);
    deviceRenameApi(data, token)
      .then(() => {
        setShowAlert({
          show: true,
          message: t("دستگاه با موفقیت ویرایش شد."),
          type: "Success",
        });
        setTimeout(() => {
          setShowAlert((prev) => ({ ...prev, show: false }));
          toggleEdit();
          dispatch(
            deviceRename({
              serial: device.serial,
              caption: values.caption,  // استفاده از values به جای ref
            })
          );
        }, 2000);
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
          setShowAlert({
            show: true,
            message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
            type: "Error",
          });
          setTimeout(() => {
            setShowAlert((prev) => ({ ...prev, show: false }));
          }, 2000);
        }
      });
  };

  const validationSchema = Yup.object({
    caption: Yup.string().required(t("نام دستگاه را وارد کنید.")),
  });

  return (
    <div className="setting-container" style={{ minHeight: "auto", padding: "24px" }}>
      <h2 className="setting-title">{t("ویرایش نام دستگاه")}</h2>

      {/* Device Info Card */}
      <div className="schedule-command-info" style={{ marginBottom: "24px" }}>
        <div className="schedule-command-icon">
          <FiHardDrive size={24} />
        </div>
        <div>
          <p className="schedule-command-label">{device.caption}</p>
          <p className="schedule-zone-name">{device.serial}</p>
        </div>
      </div>

      <Formik
        initialValues={initialValues}
        onSubmit={submitForm}
        validationSchema={validationSchema}
      >
        {(formProps) => (
          <Form ref={form}>
            {/* Device Name Field */}
            <div className="setting-item" style={{ flexDirection: "column", alignItems: "stretch", gap: "12px" }}>
              <div className="setting-item-label">
                <FiEdit size={16} />
                <span>{t("نام دستگاه")}</span>
              </div>
              <input
                type="text"
                placeholder={t("نام دستگاه")}
                name="caption"
                className="setting-input"
                defaultValue={device.caption}
                onChange={formProps.handleChange}
                onBlur={formProps.handleBlur}
              />
              <ErrorMessage name="caption">
                {(errMsg) => <div className="setting-error">{errMsg}</div>}
              </ErrorMessage>
            </div>

            {/* Action Buttons */}
            <div className="setting-buttons">
              <button
                type="button"
                className="setting-back-btn"
                onClick={toggleEdit}
                style={{ background: "var(--bg-white)", color: "var(--text-primary)", border: "2px solid var(--border-color)" }}
              >
                <FiArrowLeft size={18} />
                <span>{t("انصراف")}</span>
              </button>
              <button type="submit" className="setting-back-btn">
                <FiSave size={18} />
                <span>{t("ویرایش")}</span>
              </button>
            </div>
          </Form>
        )}
      </Formik>

      {showAlert.show && (
        <Alert message={showAlert.message} type={showAlert.type} />
      )}
    </div>
  );
};

const EditDevice = withRouter(EditDeviceComp);

export { EditDevice };